'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useUI } from '@/contexts/UIContext'

interface NavItem {
  id: number
  top_id: number | null
  platform: string
  name: string
  desc?: string
  url: string
  path?: string
  icon: string
  sort: number
  nav: number
}

interface LeftPanelProps {
  title: string
  icon: string
  items: NavItem[]
  activeIds: number[]
}

export function LeftPanel({ title, icon, items, activeIds }: LeftPanelProps) {
  const pathname = usePathname()
  const { leftPanelCollapsed: collapsed, setLeftPanelCollapsed: setCollapsed } = useUI()

  if (items.length === 0) return null

  // Icon render fonksiyonu
  const renderIcon = (iconName: string) => {
    if (iconName && iconName.startsWith('fa-')) {
      return <i className={iconName} style={{ fontSize: '16px' }} />
    }
    return <i className="fa-regular fa-list" style={{ fontSize: '16px' }} />
  }

  return (
    <div className={`panel-leftpanel ${collapsed ? 'panel-leftpanel--collapsed' : ''}`}>
      <div className="panel-leftpanel__header">
        <div className="panel-leftpanel__title">
          {renderIcon(icon)}
          <span>{title}</span>
        </div>
      </div>
      
      {/* Toggle butonu - sağ border üzerinde */}
      <button 
        className="panel-leftpanel__toggle"
        onClick={() => setCollapsed(!collapsed)}
        title={collapsed ? 'Genişlet' : 'Daralt'}
      >
        <i className={`fa-solid fa-chevron-${collapsed ? 'right' : 'left'}`} style={{ fontSize: '9px' }} />
      </button>
      
      {!collapsed && (
        <nav className="panel-leftpanel__nav">
          <div className="panel-leftpanel__group">
            <div className="panel-leftpanel__group-header">
              <i className="fa-solid fa-list" style={{ fontSize: '15px', color: '#5a5e9a' }} />
              <span className="panel-leftpanel__group-title">İÇERİKLER</span>
              <i className="fa-solid fa-chevron-down" style={{ fontSize: '10px', color: '#9ca3af' }} />
            </div>
            {items.map((item) => (
              <Link
                key={item.id}
                href={item.url || '#'}
                className={`panel-leftpanel__item ${activeIds.includes(item.id) ? 'panel-leftpanel__item--active' : ''}`}
              >
                <span className="panel-leftpanel__item-text">{item.name}</span>
                {item.url && pathname === item.url && (
                  <i className="fa-solid fa-chevron-right" style={{ fontSize: '9px' }} />
                )}
              </Link>
            ))}
          </div>
        </nav>
      )}
    </div>
  )
}
